import type {ReactNode} from 'react';

/**
 * O bloco de título das telas NOVAS.
 *
 * Repete a geometria de `PanelPage`, em `app/router.tsx`, sem reaproveitar
 * aquele componente de propósito: `PanelPage` desenha as quatro telas travadas
 * por comparação de pixel, e generalizá-lo para atender também estas duas seria
 * mexer no caminho de render aprovado para servir a quem chegou depois.
 */
export const PageTitle = ({
  title,
  subtitle,
  badge,
  children,
}: {
  title: string;
  subtitle: string;
  badge: string;
  /** Ações de contexto, à direita do subtítulo. */
  children?: ReactNode;
}) => (
  <div className="dm-page-title">
    <div>
      <h1>{title}</h1>
      <p className="dm-subtitle">{subtitle}</p>
    </div>
    <span className="dm-illustrative">{badge}</span>
    {children}
  </div>
);
